<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M6.83625 16.5578C8.12415 18.3056 10.166 19.3373 12.3371 19.3373C14.5082 19.3373 16.55 18.3056 17.8379 16.5578H19.6779C18.2125 19.1969 15.4228 20.8251 12.4042 20.8032C9.3884 20.8237 6.60226 19.1954 5.14 16.5578H6.83625ZM11.8196 9.54276L13.4488 10.5011L15.5858 9.54276H24L19.9942 16.2511H13.9854L14.3208 15.3503L12.2413 16.2511H9.165L8.03417 15.4844L7.46875 16.2511H1L5.00583 9.54276H11.8196ZM7.31542 11.3253H5.98333L4.06667 14.4782H5.025L6.16542 12.5615L5.53292 14.4782H6.36667L8.05333 12.5615L6.85542 14.4782H7.81375L9.73042 11.3253H8.36L6.75 13.0886L7.31542 11.3253ZM13.0654 11.3253H10.3246L8.40792 14.4782H11.2829L11.7813 13.6732H10.0179L10.315 13.1844H11.8867L12.3467 12.4657H10.7654L10.9954 12.0919H12.6246L13.0654 11.3253ZM14.9821 11.3253H13.65L11.7333 14.4782H12.6917L13.8225 12.5615L13.19 14.4782H14.0333L15.72 12.5615L14.5125 14.4782H15.4708L17.3875 11.3253H16.0267L14.4167 13.0886L14.9821 11.3253ZM20.0421 11.3253H18.8729L15.7679 14.4782H16.9946L17.445 13.9798H18.4033L18.25 14.4782H19.3521L20.0421 11.3253ZM18.8729 12.389L18.6238 13.2228H18.1254L18.8729 12.389ZM12.4042 5.00026C15.3654 4.97692 18.1121 6.54226 19.6013 9.10192H17.7325C16.4402 7.43269 14.4481 6.45559 12.3371 6.45559C10.2261 6.45559 8.23395 7.43269 6.94167 9.10192H5.21667C6.70268 6.54378 9.44581 4.97837 12.4042 5.00026Z"
                :fill="color" 
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgMEMAHome',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>